export const bigCarrotIcon = 'carousel-big-carrot';
export const bigCarrotIconGym = 'carousel-big-carrot-white';

/**
 * Module height and width.
 * Height is fixed for mobile : TCP & Gymb
 * */
export const MODULE_TCP_HEIGHT = 412;
export const MODULE_GYM_HEIGHT = 500;
